export default __webpack_public_path__ + "static/serviceImg1-c980dd7fe077c7069d3b4baf5a95ac7d.jpeg";